// Order-funnel beacons — the same three steps the whole network reports,
// mapped onto the voice conversation's six points (plan §5.2):
//
//   ✓ Autó card filed        -> POST /visitor_session {vehicle_id}  -> Order_Start
//   battery picked           -> POST /visitor_session {product_id}  -> Order_Cart
//   price breakdown / final  -> POST /visitor_session {combined: 1} -> Order_Start
//
// The API deduplicates Order_Start to ONE per session (ga_event_sent flag).
// vehicle_id/product_id also land on the durable visitor_session_utm row,
// feeding order#AutoMatchVisitorSession's car-veto when an operator later
// takes this caller's order by phone — instrumentation and matching improve
// together. Server pings are first-party and NOT consent-gated; the GA4
// events ARE consent-gated via gaTrackEvent.
import apiClient from '../api/client'
import { gaTrackEvent } from './analytics'

let startNotified = false

/** The assistant identified the visitor's car (the ✓ Autó card was filed). */
export function notifyVehicleSelected(vehicleId: number): void {
	if (!Number.isFinite(vehicleId) || vehicleId <= 0) return

	if (!startNotified) {
		startNotified = true
		gaTrackEvent('Order_Start')
	}

	apiClient.post('/visitor_session', { vehicle_id: String(vehicleId) }).catch(() => {})
}

/** A battery was chosen from the option cards (classic Order_Cart). */
export function notifyOrderCart(productId: number): void {
	if (!Number.isFinite(productId) || productId <= 0) return

	gaTrackEvent('Order_Cart')

	apiClient.post('/visitor_session', { product_id: String(productId) }).catch(() => {})
}

/** The price breakdown / final confirm is on screen (checkout equivalent). */
export function notifyCheckoutStarted(): void {
	if (!startNotified) {
		startNotified = true
		gaTrackEvent('Order_Start')
	}

	apiClient.post('/visitor_session', { combined: '1' }).catch(() => {})
}
